export default __webpack_public_path__ + "images/29eee04896067ca302fbb9b8329edbc4.svg";